import React from "react";
import { Button, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiRedo, mdiUndo } from "@mdi/js";

const MarkupToolbar = ({
  canUndo,
  canRedo,
  canClear,
  canComplete,
  isSaving,
  onUndo,
  onRedo,
  onClear,
  onComplete,
}) => (
  <div className="markup-toolbar">
    <div className="markup-toolbar-left">
      <Button
        className="markup-toolbar-clear-btn"
        onClick={onClear}
        disabled={!canClear || isSaving}
      >
        Clear
      </Button>
    </div>
    <div className="markup-toolbar-right">
      <Button
        className="markup-toolbar-history-btn"
        onClick={onUndo}
        disabled={!canUndo || isSaving}
      >
        <Icon path={mdiUndo} size={1} /> Undo
      </Button>
      <Button
        className="markup-toolbar-history-btn"
        onClick={onRedo}
        disabled={!canRedo || isSaving}
      >
        <Icon path={mdiRedo} size={1} /> Redo
      </Button>
      <Button
        className="markup-toolbar-complete-btn"
        onClick={onComplete}
        disabled={!canComplete || isSaving}
      >
        {isSaving ? (
          <>
            <Spinner animation="border" size="sm" /> Saving...
          </>
        ) : (
          "Complete"
        )}
      </Button>
    </div>
  </div>
);

export default MarkupToolbar;
